import * as yup from "yup";

const UserInfoStepValidation = yup.object().shape({
	userInfo: yup.object().shape({
		name: yup
			.string()
			.required("Lütfen adınızı giriniz.")
			.test(
				"nameLength",
				"Lütfen adınızı giriniz.",
				(val) => val?.trim().length !== undefined && val?.trim().length > 0
			),
		surname: yup
			.string()
			.required("Lütfen soyadınızı giriniz.")
			.test(
				"surnameLength",
				"Lütfen soyadınızı giriniz.",
				(val) => val?.trim().length !== undefined && val?.trim().length > 0
			),
		job: yup.string().required("Lütfen mesleğinizi seçiniz."),
		title: yup.string(),
		phone: yup
			.string()
			.required("Lütfen telefon numarınızı giriniz.")
			.test(
				"phoneNumberLength",
				"Telefon numarası geçerli formatta olmalıdır.",
				(val) => !val?.includes("_") && val?.length === 16
			),
		gsm: yup.string(),
		companyType: yup
			.string()
			.required("Lütfen kuruluşunuzun türünüzü seçiniz."),
		companyName: yup
			.string()
			.required("Lütfen kuruluşunuzun adını giriniz.")
			.test(
				"companyNameLength",
				"Lütfen kuruluşunuzun adını giriniz.",
				(val) => val?.trim().length !== undefined && val?.trim().length > 0
			),
		province: yup.string().required("Lütfen ilinizi seçiniz."),
		district: yup.string(),
		address: yup
			.string()
			.required("Lütfen adresinizi giriniz.")
			.test(
				"addressLength",
				"Lütfen adresinizi giriniz.",
				(val) => val?.trim().length !== undefined && val?.trim().length > 0
			),
		isAgreementApprove: yup.boolean().isTrue(),
	}),
});

export default UserInfoStepValidation;
